'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var Node = require('./node');
/**
 * Singleton subclass of an empty Collection.
 */


var Empty =
/*#__PURE__*/
function (_Node) {
  (0, _inherits2.default)(Empty, _Node);

  function Empty() {
    var _this;

    (0, _classCallCheck2.default)(this, Empty);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Empty).call(this));
    _this.termType = Empty.termType;
    return _this;
  }

  (0, _createClass2.default)(Empty, [{
    key: "toString",
    value: function toString() {
      return '()';
    }
  }]);
  return Empty;
}(Node);

Empty.termType = 'empty';
module.exports = Empty;